module.exports = __webpack_public_path__ + "img/activePagePcBgZh.2c8e85a9.png";